export const cfcVsBfcMyTeamsList = [
  {
    _id: '63d11c9c8d8436001e1bed5f',
    createdOn: '2023-01-25T12:12:12.409Z',
    deletedOn: null,
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cc161b6bc8d3ddb98f73a3',
    viceCaptainId: '63cc161b6bc8d3ddb98f7387',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cc161b6bc8d3ddb98f73b6',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f7387',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f73a3',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f73c1',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f7374',
        rating: 8,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f7388',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f738a',
        rating: 9,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f7376',
        rating: 8.5,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f73a2',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f73b5',
        rating: 8.5,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63cc161b6bc8d3ddb98f73cb',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ],
    captain: {
      _id: '63cc161b6bc8d3ddb98f73a3',
      matchId: '63cc159c6bc8d3ddb98f5cf6',
      playerId: '64021',
      name: 'Namgyal Bhutia',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 8.5,
      role: 'Defender',
      shortName: 'Namgyal Bhutia',
      substitute: false,
      teamId: '451',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/451.png',
      totalPoints: 0
    },
    viceCaptain: {
      _id: '63cc161b6bc8d3ddb98f7387',
      matchId: '63cc159c6bc8d3ddb98f5cf6',
      playerId: '202637',
      name: 'Aakash Sangwan',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 8.5,
      role: 'Defender',
      shortName: 'Aakash Sangwan',
      substitute: false,
      teamId: '453',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/453.png',
      totalPoints: 0
    },
    id: '63d11c9c8d8436001e1bed5f'
  }
];
export const odiVsBfcMyTeamsList = [
  {
    _id: '635a2c85027fb4001b93a110',
    createdOn: '2022-10-27T07:00:20.907Z',
    deletedOn: null,
    matchId: '6352d31ce1e4df00fa125db2',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '6352d39ae1e4df00fa126b00',
    viceCaptainId: '6352d39ae1e4df00fa126b16',
    score: 336,
    teamNumber: 1,
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b0a',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126aeb',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126afb',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b00',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af7',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126b09',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      }
    ],
    verifiedScore: 336,
    captain: {
      _id: '6352d39ae1e4df00fa126b00',
      matchId: '6352d31ce1e4df00fa125db2',
      playerId: '64053',
      name: 'Thoiba Singh Moirangthem',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: true,
      playingEleven: true,
      playingRole: 'Defender',
      points: {
        pid: '64053',
        pname: 'Thoiba Singh Moirangthem',
        points: 40,
        starting11: 4,
        substitute: 0,
        goal: 0,
        assist: 0,
        shotsontarget: 0,
        chancecreated: 3,
        passes: 5,
        tacklewon: 4,
        interceptionwon: 4,
        saves: 0,
        penaltysaved: 0,
        cleansheet: 20,
        yellowcard: 0,
        redcard: 0,
        owngoal: 0,
        goalsconceded: 0,
        penaltymissed: 0,
        team_id: '454',
        mid: '174223',
        modifiedOn: '2022-10-27T18:22:02.441Z'
      },
      rating: 8.5,
      role: 'Defender',
      shirtnumber: '24',
      shortName: 'Thoiba Singh Moirangthem',
      stats: {
        pid: 64053,
        pname: 'Thoiba Singh Moirangthem',
        teamtype: 'home',
        minutesplayed: 81,
        assist: 0,
        goals: 0,
        shotsontarget: 0,
        shotsofftarget: 1,
        shotsblocked: 1,
        dribbleattempts: 1,
        dribblesuccess: 0,
        bigchancemissed: 0,
        penaltywon: 0,
        hitwoodwork: 0,
        penaltymiss: 0,
        totalclearance: 1,
        outfielderblock: 0,
        interceptionwon: 1,
        tacklecommitted: 1,
        tacklesuccess: 1,
        challengelost: 0,
        owngoals: 0,
        penaltycommitted: 0,
        errorledtoshot: 0,
        lastmantackle: 0,
        clearanceoffline: 0,
        passingaccuracy: 75,
        accuratepass: 24,
        totalpass: 32,
        longballsacc: 2,
        totallongballs: 3,
        totalcross: 0,
        crossesacc: 0,
        bigchancecreated: 0,
        errorledtogoal: 0,
        dispossessed: 1,
        duelstotal: 5,
        duelswon: 5,
        wasfouled: 0,
        fouls: 1,
        runsoutsucess: 0,
        totalrunsout: 0,
        goodhighclaim: 0,
        punches: 0,
        saves: 0,
        savesfrominsidebox: 0,
        penaltysave: 0,
        keypass: 1,
        yellowcard: 0,
        redcard: 0,
        goalconceded: 0,
        cleansheet: 1,
        team_id: '454',
        mid: '174223',
        modifiedOn: '2022-10-27T18:22:09.056Z'
      },
      substitute: false,
      teamId: '454',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/454.png',
      totalPoints: 40,
      lastPoints: 40
    },
    viceCaptain: {
      _id: '6352d39ae1e4df00fa126b16',
      matchId: '6352d31ce1e4df00fa125db2',
      playerId: '8811',
      name: 'Sahil Panwar',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: true,
      playingEleven: true,
      playingRole: 'Defender',
      points: {
        pid: '8811',
        pname: 'Sahil Panwar',
        points: 50,
        starting11: 4,
        substitute: 0,
        goal: 0,
        assist: 0,
        shotsontarget: 0,
        chancecreated: 6,
        passes: 4,
        tacklewon: 16,
        interceptionwon: 0,
        saves: 0,
        penaltysaved: 0,
        cleansheet: 20,
        yellowcard: 0,
        redcard: 0,
        owngoal: 0,
        goalsconceded: 0,
        penaltymissed: 0,
        team_id: '454',
        mid: '174223',
        modifiedOn: '2022-10-27T18:22:02.426Z'
      },
      rating: 8.5,
      role: 'Defender',
      shirtnumber: '36',
      shortName: 'Sahil Panwar',
      stats: {
        pid: 8811,
        pname: 'Sahil Panwar',
        teamtype: 'home',
        minutesplayed: 90,
        assist: 0,
        goals: 0,
        shotsontarget: 0,
        shotsofftarget: 0,
        shotsblocked: 0,
        dribbleattempts: 0,
        dribblesuccess: 0,
        bigchancemissed: 0,
        penaltywon: 0,
        hitwoodwork: 0,
        penaltymiss: 0,
        totalclearance: 7,
        outfielderblock: 0,
        interceptionwon: 0,
        tacklecommitted: 5,
        tacklesuccess: 5,
        challengelost: 2,
        owngoals: 0,
        penaltycommitted: 0,
        errorledtoshot: 0,
        lastmantackle: 0,
        clearanceoffline: 0,
        passingaccuracy: 60,
        accuratepass: 21,
        totalpass: 35,
        longballsacc: 4,
        totallongballs: 9,
        totalcross: 5,
        crossesacc: 2,
        bigchancecreated: 0,
        errorledtogoal: 0,
        dispossessed: 0,
        duelstotal: 12,
        duelswon: 12,
        wasfouled: 0,
        fouls: 0,
        runsoutsucess: 0,
        totalrunsout: 0,
        goodhighclaim: 0,
        punches: 0,
        saves: 0,
        savesfrominsidebox: 0,
        penaltysave: 0,
        keypass: 2,
        yellowcard: 0,
        redcard: 0,
        goalconceded: 0,
        cleansheet: 1,
        team_id: '454',
        mid: '174223',
        modifiedOn: '2022-10-27T18:22:09.047Z'
      },
      substitute: false,
      teamId: '454',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/454.png',
      totalPoints: 50,
      lastPoints: 50
    },
    id: '635a2c85027fb4001b93a110'
  }
];
export const cfcVsBfcResultMyTeamsList = [
  {
    _id: '634966c7b99cfd001d9cf522',
    createdOn: '2022-10-14T13:40:23.114Z',
    deletedOn: null,
    matchId: '63445a1c746a9884afab2c59',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63445a98746a9884afab39f3',
    viceCaptainId: '63445a98746a9884afab3a2e',
    score: 387,
    teamNumber: 6,
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ],
    verifiedScore: 387,
    captain: {
      _id: '63445a98746a9884afab39f3',
      matchId: '63445a1c746a9884afab2c59',
      playerId: '6018',
      name: 'Roy Krishna',
      nationality: {
        iocid: '71',
        name: 'Fiji',
        ioc: ''
      },
      played: true,
      playingEleven: true,
      playingRole: 'Forward',
      points: {
        pid: '6018',
        pname: 'Roy Krishna',
        points: 51,
        starting11: 4,
        substitute: 0,
        goal: 40,
        assist: 0,
        shotsontarget: 6,
        chancecreated: 0,
        passes: 1,
        tacklewon: 0,
        interceptionwon: 4,
        saves: 0,
        penaltysaved: 0,
        cleansheet: 0,
        yellowcard: -4,
        redcard: 0,
        owngoal: 0,
        goalsconceded: 0,
        penaltymissed: 0,
        team_id: '451',
        mid: '174215',
        modifiedOn: '2022-10-14T18:46:04.098Z'
      },
      rating: 9,
      role: 'Forward',
      shirtnumber: '22',
      shortName: 'Roy Krishna',
      stats: {
        pid: 6018,
        pname: 'Roy Krishna',
        teamtype: 'away',
        minutesplayed: 90,
        assist: 0,
        goals: 1,
        shotsontarget: 1,
        shotsofftarget: 0,
        shotsblocked: 1,
        dribbleattempts: 0,
        dribblesuccess: 0,
        bigchancemissed: 0,
        penaltywon: 0,
        hitwoodwork: 0,
        penaltymiss: 0,
        totalclearance: 0,
        outfielderblock: 0,
        interceptionwon: 0,
        tacklecommitted: 0,
        tacklesuccess: 0,
        challengelost: 0,
        owngoals: 0,
        penaltycommitted: 0,
        errorledtoshot: 0,
        lastmantackle: 0,
        clearanceoffline: 0,
        passingaccuracy: 58.33,
        accuratepass: 7,
        totalpass: 12,
        longballsacc: 1,
        totallongballs: 1,
        totalcross: 0,
        crossesacc: 0,
        bigchancecreated: 0,
        errorledtogoal: 0,
        dispossessed: 0,
        duelstotal: 2,
        duelswon: 2,
        wasfouled: 2,
        fouls: 0,
        runsoutsucess: 0,
        totalrunsout: 0,
        goodhighclaim: 0,
        punches: 0,
        saves: 0,
        savesfrominsidebox: 0,
        penaltysave: 0,
        keypass: 0,
        yellowcard: 0,
        redcard: 0,
        goalconceded: 1,
        cleansheet: 0,
        team_id: '451',
        mid: '174215',
        modifiedOn: '2022-10-14T18:46:11.123Z'
      },
      substitute: false,
      teamId: '451',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/451.png',
      totalPoints: 51,
      lastPoints: 51
    },
    viceCaptain: {
      _id: '63445a98746a9884afab3a2e',
      matchId: '63445a1c746a9884afab2c59',
      playerId: '100362',
      name: 'Bruno Silva Almeida',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: true,
      playingEleven: true,
      playingRole: 'Midfielder',
      points: {
        pid: '100362',
        pname: 'Bruno Silva Almeida',
        points: 28,
        starting11: 4,
        substitute: 0,
        goal: 0,
        assist: 0,
        shotsontarget: 0,
        chancecreated: 0,
        passes: 8,
        tacklewon: 12,
        interceptionwon: 4,
        saves: 0,
        penaltysaved: 0,
        cleansheet: 0,
        yellowcard: 0,
        redcard: 0,
        owngoal: 0,
        goalsconceded: 0,
        penaltymissed: 0,
        team_id: '451',
        mid: '174215',
        modifiedOn: '2022-10-14T18:46:04.106Z'
      },
      rating: 8.5,
      role: 'Midfielder',
      shirtnumber: '6',
      shortName: 'Bruno Silva Almeida',
      stats: {
        pid: 100362,
        pname: 'Bruno Silva Almeida',
        teamtype: 'away',
        minutesplayed: 90,
        assist: 0,
        goals: 0,
        shotsontarget: 0,
        shotsofftarget: 0,
        shotsblocked: 0,
        dribbleattempts: 1,
        dribblesuccess: 1,
        bigchancemissed: 0,
        penaltywon: 0,
        hitwoodwork: 0,
        penaltymiss: 0,
        totalclearance: 2,
        outfielderblock: 0,
        interceptionwon: 1,
        tacklecommitted: 4,
        tacklesuccess: 4,
        challengelost: 0,
        owngoals: 0,
        penaltycommitted: 0,
        errorledtoshot: 0,
        lastmantackle: 0,
        clearanceoffline: 0,
        passingaccuracy: 80.36,
        accuratepass: 45,
        totalpass: 56,
        longballsacc: 3,
        totallongballs: 7,
        totalcross: 0,
        crossesacc: 0,
        bigchancecreated: 0,
        errorledtogoal: 0,
        dispossessed: 0,
        duelstotal: 7,
        duelswon: 7,
        wasfouled: 0,
        fouls: 0,
        runsoutsucess: 0,
        totalrunsout: 0,
        goodhighclaim: 0,
        punches: 0,
        saves: 0,
        savesfrominsidebox: 0,
        penaltysave: 0,
        keypass: 0,
        yellowcard: 0,
        redcard: 0,
        goalconceded: 1,
        cleansheet: 0,
        team_id: '451',
        mid: '174215',
        modifiedOn: '2022-10-14T18:46:11.137Z'
      },
      substitute: false,
      teamId: '451',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/451.png',
      totalPoints: 28,
      lastPoints: 28
    },
    id: '634966c7b99cfd001d9cf522'
  }
];
export const atkMBVsCfcMyTeamsList = [
  {
    _id: '6343eaafc2760c001bcd40ad',
    createdOn: '2022-10-10T09:49:34.933Z',
    deletedOn: null,
    matchId: '633ec64c746a9884af15dc05',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '633fb1e0746a9884af2fbe2e',
    viceCaptainId: '633fb1e0746a9884af2fbe34',
    score: 59,
    teamNumber: 1,
    players: [
      {
        teamId: 453,
        role: 'Goalkeeper',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe30'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2e'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe34'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe51'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe37'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe44'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2d'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe31'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe4a'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe33'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe45'
      }
    ],
    verifiedScore: 59,
    captain: {
      _id: '633fb1e0746a9884af2fbe2e',
      matchId: '633ec64c746a9884af15dc05',
      playerId: '6066',
      name: 'Brendan Hamill',
      nationality: {
        iocid: '13',
        name: 'Australia',
        ioc: ''
      },
      played: true,
      playingEleven: true,
      playingRole: 'Defender',
      points: {
        pid: 6066,
        pname: 'Brendan Hamill',
        points: 3,
        minutesplayed: 2,
        goalscored: 0,
        assist: 0,
        passes: 2,
        shotsontarget: 0,
        cleansheet: 0,
        shotssaved: 0,
        penaltysaved: 0,
        tacklesuccessful: 0,
        yellowcard: 0,
        redcard: 0,
        owngoal: 0,
        goalsconceded: -1,
        penaltymissed: 0,
        team_id: '2029',
        mid: '174211',
        modifiedOn: '2022-10-10T19:26:01.992Z'
      },
      rating: 9,
      role: 'Defender',
      shirtnumber: '5',
      shortName: 'Brendan Hamill',
      stats: {
        pid: 6066,
        pname: 'Brendan Hamill',
        teamtype: 'home',
        minutesplayed: 90,
        assist: 0,
        goals: 0,
        shotsontarget: 0,
        shotsofftarget: 0,
        shotsblocked: 0,
        dribbleattempts: 0,
        dribblesuccess: 0,
        bigchancemissed: 0,
        penaltywon: 0,
        hitwoodwork: 0,
        penaltymiss: 0,
        totalclearance: 3,
        outfielderblock: 0,
        interceptionwon: 0,
        tacklecommitted: 1,
        tacklesuccess: 1,
        challengelost: 0,
        owngoals: 0,
        penaltycommitted: 0,
        errorledtoshot: 0,
        lastmantackle: 0,
        clearanceoffline: 0,
        passingaccuracy: 94.12,
        accuratepass: 48,
        totalpass: 51,
        longballsacc: 1,
        totallongballs: 2,
        totalcross: 0,
        crossesacc: 0,
        bigchancecreated: 0,
        errorledtogoal: 0,
        dispossessed: 0,
        duelstotal: 2,
        duelswon: 2,
        wasfouled: 0,
        fouls: 0,
        runsoutsucess: 0,
        totalrunsout: 0,
        goodhighclaim: 0,
        punches: 0,
        saves: 0,
        savesfrominsidebox: 0,
        penaltysave: 0,
        keypass: 0,
        yellowcard: 0,
        redcard: 0,
        goalconceded: 2,
        cleansheet: 0,
        team_id: '2029',
        mid: '174211',
        modifiedOn: '2022-10-10T19:26:07.934Z'
      },
      substitute: false,
      teamId: '2029',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/2029.png',
      totalPoints: 3,
      lastPoints: 3
    },
    viceCaptain: {
      _id: '633fb1e0746a9884af2fbe34',
      matchId: '633ec64c746a9884af15dc05',
      playerId: '8739',
      name: 'Pritam Kotal',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: true,
      playingEleven: true,
      playingRole: 'Defender',
      points: {
        pid: 8739,
        pname: 'Pritam Kotal',
        points: 3,
        minutesplayed: 2,
        goalscored: 0,
        assist: 0,
        passes: 2,
        shotsontarget: 0,
        cleansheet: 0,
        shotssaved: 0,
        penaltysaved: 0,
        tacklesuccessful: 0,
        yellowcard: 0,
        redcard: 0,
        owngoal: 0,
        goalsconceded: -1,
        penaltymissed: 0,
        team_id: '2029',
        mid: '174211',
        modifiedOn: '2022-10-10T19:26:01.994Z'
      },
      rating: 9,
      role: 'Defender',
      shirtnumber: '20',
      shortName: 'Pritam Kotal',
      stats: {
        pid: 8739,
        pname: 'Pritam Kotal',
        teamtype: 'home',
        minutesplayed: 90,
        assist: 0,
        goals: 0,
        shotsontarget: 0,
        shotsofftarget: 0,
        shotsblocked: 0,
        dribbleattempts: 0,
        dribblesuccess: 0,
        bigchancemissed: 0,
        penaltywon: 0,
        hitwoodwork: 0,
        penaltymiss: 0,
        totalclearance: 4,
        outfielderblock: 0,
        interceptionwon: 0,
        tacklecommitted: 0,
        tacklesuccess: 0,
        challengelost: 0,
        owngoals: 0,
        penaltycommitted: 0,
        errorledtoshot: 0,
        lastmantackle: 0,
        clearanceoffline: 0,
        passingaccuracy: 80,
        accuratepass: 44,
        totalpass: 55,
        longballsacc: 3,
        totallongballs: 8,
        totalcross: 2,
        crossesacc: 0,
        bigchancecreated: 0,
        errorledtogoal: 0,
        dispossessed: 0,
        duelstotal: 1,
        duelswon: 1,
        wasfouled: 0,
        fouls: 0,
        runsoutsucess: 0,
        totalrunsout: 0,
        goodhighclaim: 0,
        punches: 0,
        saves: 0,
        savesfrominsidebox: 0,
        penaltysave: 0,
        keypass: 0,
        yellowcard: 0,
        redcard: 0,
        goalconceded: 2,
        cleansheet: 0,
        team_id: '2029',
        mid: '174211',
        modifiedOn: '2022-10-10T19:26:07.937Z'
      },
      substitute: false,
      teamId: '2029',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/2029.png',
      totalPoints: 3,
      lastPoints: 3
    },
    id: '6343eaafc2760c001bcd40ad'
  }
];
export const jfcVsMcfMyTeamsList = [
  {
    _id: '63d33e348d8436001e1bedb8',
    createdOn: '2023-01-27T03:00:04.294Z',
    deletedOn: null,
    matchId: '63cb03286bc8d3ddb965e21b',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cb036d6bc8d3ddb965eeb0',
    viceCaptainId: '63cb036d6bc8d3ddb965eea1',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cb036d6bc8d3ddb965eeb4',
        rating: 7.5,
        teamId: 458,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea2',
        rating: 8.5,
        teamId: 458,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965ee9a',
        rating: 8,
        teamId: 460,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eeac',
        rating: 8,
        teamId: 458,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eeb7',
        rating: 8,
        teamId: 458,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eec1',
        rating: 9,
        teamId: 458,
        role: 'Midfielder'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea1',
        rating: 8.5,
        teamId: 458,
        role: 'Midfielder'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eeb0',
        rating: 8.5,
        teamId: 460,
        role: 'Midfielder'
      },
      {
        playerId: '63cb036d6bc8d3ddb965ee9b',
        rating: 9,
        teamId: 458,
        role: 'Forward'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea3',
        rating: 9,
        teamId: 460,
        role: 'Forward'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea4',
        rating: 8,
        teamId: 460,
        role: 'Forward'
      }
    ],
    captain: {
      _id: '63cb036d6bc8d3ddb965eeb0',
      matchId: '63cb03286bc8d3ddb965e21b',
      playerId: '65300',
      name: 'Boris Thangjam',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Midfielder',
      rating: 8.5,
      role: 'Midfielder',
      shortName: 'Boris Thangjam',
      substitute: false,
      teamId: '460',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/460.png',
      totalPoints: 0
    },
    viceCaptain: {
      _id: '63cb036d6bc8d3ddb965eea1',
      matchId: '63cb03286bc8d3ddb965e21b',
      playerId: '28216',
      name: 'Lallianzuala Chhangte',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Midfielder',
      rating: 8.5,
      role: 'Midfielder',
      shortName: 'Lallianzuala Chhangte',
      substitute: false,
      teamId: '458',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/458.png',
      totalPoints: 0
    },
    id: '63d33e348d8436001e1bedb8'
  }
];
export const kerVsNorMyTeamsList = [
  {
    _id: '63d3bf3a8d8436001e1bee05',
    createdOn: '2023-01-27T12:10:34.781Z',
    deletedOn: null,
    matchId: '63d29ad46bc8d3ddb9782e01',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63d29b536bc8d3ddb978416b',
    viceCaptainId: '63d29b536bc8d3ddb9784170',
    score: 0,
    teamNumber: 2,
    players: [
      {
        playerId: '63d29b536bc8d3ddb978416a',
        rating: 7,
        teamId: 459,
        role: 'Goalkeeper'
      },
      {
        playerId: '63d29b536bc8d3ddb9784154',
        rating: 8,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784137',
        rating: 7.5,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784145',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784157',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb978416b',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784170',
        rating: 9,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978414e',
        rating: 8.5,
        teamId: 459,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978417f',
        rating: 8.5,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978415a',
        rating: 8,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb9784183',
        rating: 9,
        teamId: 457,
        role: 'Forward'
      }
    ],
    captain: {
      _id: '63d29b536bc8d3ddb978416b',
      matchId: '63d29ad46bc8d3ddb9782e01',
      playerId: '64100',
      name: 'Mohammed Irshad',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 7.5,
      role: 'Defender',
      shortName: 'Mohammed Irshad',
      substitute: false,
      teamId: '459',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/459.png',
      totalPoints: 0
    },
    viceCaptain: {
      _id: '63d29b536bc8d3ddb9784170',
      matchId: '63d29ad46bc8d3ddb9782e01',
      playerId: '82894',
      name: 'Ivan Kalyuzhny Volodymyrovych',
      nationality: {
        iocid: '223',
        name: 'Ukraine',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Midfielder',
      rating: 9,
      role: 'Midfielder',
      shortName: 'Ivan Kalyuzhny Volodymyrovych',
      substitute: false,
      teamId: '457',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/457.png',
      totalPoints: 0
    },
    id: '63d3bf3a8d8436001e1bee05'
  },
  {
    _id: '63d341578d8436001e1bedc0',
    createdOn: '2023-01-27T03:13:27.567Z',
    deletedOn: null,
    matchId: '63d29ad46bc8d3ddb9782e01',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63d29b536bc8d3ddb9784145',
    viceCaptainId: '63d29b536bc8d3ddb9784157',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63d29b536bc8d3ddb978416a',
        rating: 7,
        teamId: 459,
        role: 'Goalkeeper'
      },
      {
        playerId: '63d29b536bc8d3ddb9784154',
        rating: 8,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784137',
        rating: 7.5,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784145',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784157',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb978416b',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784170',
        rating: 9,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978414e',
        rating: 8.5,
        teamId: 459,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978417f',
        rating: 8.5,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978415a',
        rating: 8,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb9784183',
        rating: 9,
        teamId: 457,
        role: 'Forward'
      }
    ],
    captain: {
      _id: '63d29b536bc8d3ddb9784145',
      matchId: '63d29ad46bc8d3ddb9782e01',
      playerId: '197054',
      name: 'Aaron Michael Evans',
      nationality: {
        iocid: '13',
        name: 'Australia',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 7.5,
      role: 'Defender',
      shortName: 'Aaron Michael Evans',
      substitute: false,
      teamId: '459',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/459.png',
      totalPoints: 0
    },
    viceCaptain: {
      _id: '63d29b536bc8d3ddb9784157',
      matchId: '63d29ad46bc8d3ddb9782e01',
      playerId: '47172',
      name: 'Gaurav Bora',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 7.5,
      role: 'Defender',
      shortName: 'Gaurav Bora',
      substitute: false,
      teamId: '459',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/459.png',
      totalPoints: 0
    },
    id: '63d341578d8436001e1bedc0'
  }
];
export const atkVsOdiMyTeamsList = [
  {
    _id: '63d3c0eb8d8436001e1bee0f',
    createdOn: '2023-01-27T12:17:47.170Z',
    deletedOn: null,
    matchId: '63cda4c06bc8d3ddb9c91f39',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cda5006bc8d3ddb9c92976',
    viceCaptainId: '63cda5006bc8d3ddb9c92944',
    score: 0,
    teamNumber: 2,
    players: [
      {
        playerId: '63cda5006bc8d3ddb9c92975',
        rating: 8,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928e8',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92945',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92976',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92944',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92967',
        rating: 9,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92971',
        rating: 9,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928fe',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c9292e',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92922',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92949',
        rating: 9,
        teamId: 454,
        role: 'Forward'
      }
    ],
    captain: {
      _id: '63cda5006bc8d3ddb9c92976',
      matchId: '63cda4c06bc8d3ddb9c91f39',
      playerId: '8811',
      name: 'Sahil Panwar',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 8.5,
      role: 'Defender',
      shortName: 'Sahil Panwar',
      substitute: false,
      teamId: '454',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/454.png',
      totalPoints: 0
    },
    viceCaptain: {
      _id: '63cda5006bc8d3ddb9c92944',
      matchId: '63cda4c06bc8d3ddb9c91f39',
      playerId: '47165',
      name: 'Narender Gahlot',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Defender',
      rating: 8,
      role: 'Defender',
      shortName: 'Narender Gahlot',
      substitute: false,
      teamId: '454',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/454.png',
      totalPoints: 0
    },
    id: '63d3c0eb8d8436001e1bee0f'
  },
  {
    _id: '63d3c0d48d8436001e1bee0a',
    createdOn: '2023-01-27T12:17:24.077Z',
    deletedOn: null,
    matchId: '63cda4c06bc8d3ddb9c91f39',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cda5006bc8d3ddb9c9292e',
    viceCaptainId: '63cda5006bc8d3ddb9c928fe',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cda5006bc8d3ddb9c92975',
        rating: 8,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928e8',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92945',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92976',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92944',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92971',
        rating: 9,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928fe',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c9292e',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928e9',
        rating: 8,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92922',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '63cda5006bc8d3ddb9c9297e',
        rating: 9,
        teamId: 454,
        role: 'Forward'
      }
    ],
    captain: {
      _id: '63cda5006bc8d3ddb9c9292e',
      matchId: '63cda4c06bc8d3ddb9c91f39',
      playerId: '40969',
      name: 'Saul Crespo Prieto',
      nationality: {
        iocid: '199',
        name: 'Spain',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Midfielder',
      rating: 8.5,
      role: 'Midfielder',
      shortName: 'Saul Crespo Prieto',
      substitute: false,
      teamId: '454',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/454.png',
      totalPoints: 0
    },
    viceCaptain: {
      _id: '63cda5006bc8d3ddb9c928fe',
      matchId: '63cda4c06bc8d3ddb9c91f39',
      playerId: '28202',
      name: 'Raynier Fernandes',
      nationality: {
        iocid: '99',
        name: 'India',
        ioc: ''
      },
      played: false,
      playingEleven: false,
      playingRole: 'Midfielder',
      rating: 8.5,
      role: 'Midfielder',
      shortName: 'Raynier Fernandes',
      substitute: false,
      teamId: '454',
      thumbUrl: 'https://soccer.entitysport.com/assets/team/454.png',
      totalPoints: 0
    },
    id: '63d3c0d48d8436001e1bee0a'
  }
];
